import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const HeaderWidgetButtonGroup = styled(ToggleButtonGroup)({
  display: 'flex',
  width: '100%',
});

export const HeaderWidgetButton = styled(ToggleButton)(({ theme }) => ({
  flex: 1,
  width: '100%',
  textTransform: 'capitalize',
  backgroundColor: theme.palette.primary.lightest,
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  height: '36px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.lightest,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
